import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error:", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", gap: 16, fontFamily: "system-ui, sans-serif", textAlign: "center", padding: 'var(--bx-pad)' }}>
        <div style={{ fontSize: 18, fontWeight: 600 }}>Something went wrong loading this page.</div>
        <div style={{ fontSize: 13, opacity: 0.6, maxWidth: 480 }}>{this.state.error.message}</div>
        <button
          onClick={() => { this.setState({ error: null }); window.location.reload(); }}
          style={{ padding: "8px 16px", borderRadius: 4, border: "1px solid currentColor", background: "transparent", color: "inherit", cursor: "pointer", fontSize: 13 }}
        >
          Reload
        </button>
      </div>
    );
  }
}
